let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3xS60")).then(() => parcelRequire('aO1kd'));